<template>
  <v-card
    class="mx-auto EK-card IMThemeGray rounded-xl rounded-tr-0 overflow-hidden text-right pb-5"
  >
    <v-card-title class="justify-content-center text-white">
      <strong>نتيجة الإرسال</strong>
    </v-card-title>
    <v-card-text class="pb-0">
        <v-row>
          <v-col cols="12" lg="6">
            <h5 class="green--text">الأرقام التي تم الإرسال لها بنجاح</h5>
            <v-simple-table  class="scrollable">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-right">#</th>
                    <th class="text-right">اسم المشترك</th>
                    <th class="text-right">الرقم</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="shop in succeededNumbers" :key="shop.id">
                    <td>{{ shop.id }}</td>
                    <td>{{ shop.name }}</td>
                    <td>{{ shop.mobileNumber }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" lg="6">
            <h5 class="red--text">الأرقام التي فشل الإرسال لها</h5>
            <v-simple-table class="scrollable">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-right">#</th>
                    <th class="text-right">اسم المشترك</th>
                    <th class="text-right">الرقم</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="shop in failedNumbers" :key="shop.id">
                    <td>{{ shop.id }}</td>
                    <td>{{ shop.name }}</td>
                    <td>{{ shop.mobileNumber }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
    </v-card-text>
    <v-card-actions class="justify-content-center">
      <v-btn
        type="button"
        outlined
        color="success"
        class="by-5 px-10 rounded-tr-0"
        @click="close"
      >
        تم
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style scoped>
.scrollable{
    height: 350px;
    overflow-y: auto;
}
</style>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    valid: false,
    message: "",
    shopIds: [],
  }),
  created() {},
  computed: {
    ...mapGetters(["succeededNumbers", "failedNumbers"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitForm() {
      this.close();
    },
  },
};
</script>
